<template>
  <v-card flat class="pa-4">
    <v-card outlined class="pa-4">
      <div class="setting-item mb-4">
        <v-switch
          v-model="localHasQuestionare"
          :label="$t('surveys')"
          @change="handleQuestionareChange"
          inset
          color="primary"
          hide-details
        />
      </div>

      <v-expand-transition>
        <div v-if="localHasQuestionare && localQuestionares.length > 0">
          <v-divider class="my-4"></v-divider>

          <v-card
            outlined
            v-for="(questionare, i) in localQuestionares"
            :key="i"
            class="questionare-card mb-3 pa-3"
          >
            <v-row align="center" dense>
              <v-col cols="12" sm="3">
                <text-field
                  :label="$t('survey_id')"
                  v-model="questionare.qid"
                  :disabled="!localHasQuestionare"
                  outlined
                  dense
                  hide-details
                />
              </v-col>
              <v-col cols="12" sm="7">
                <autocomplete
                  v-model="questionare.roles"
                  :label="$t('role')"
                  :items="['admin', 'guest', 'customer']"
                  :disabled="!localHasQuestionare"
                  multiple
                  small-chips
                  deletable-chips
                  dense
                  hide-details
                >
                </autocomplete>
              </v-col>
              <v-col cols="12" sm="2" class="text-center">
                <div
                  v-if="i === localQuestionares.length - 1"
                  class="d-flex justify-center"
                >
                  <v-btn
                    @click="removeQuestionare(i)"
                    :disabled="!localHasQuestionare"
                    icon
                    small
                    color="error"
                  >
                    <v-icon>mdi-minus-circle</v-icon>
                  </v-btn>
                  <v-btn
                    @click="addQuestionare"
                    :disabled="!localHasQuestionare"
                    icon
                    small
                    color="success"
                  >
                    <v-icon>mdi-plus-circle</v-icon>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </div>
      </v-expand-transition>
    </v-card>
  </v-card>
</template>

<script>
export default {
  name: "QuestionnaireSettingsTab",
  props: {
    questionares: {
      type: Array,
      required: true,
    },
    hasQuestionare: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      localQuestionares: [...this.questionares],
      localHasQuestionare: this.hasQuestionare,
    };
  },
  watch: {
    questionares: {
      handler(newVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(this.localQuestionares)) {
          this.localQuestionares = [...newVal];
        }
      },
      deep: true,
    },
    hasQuestionare(newVal) {
      if (newVal !== this.localHasQuestionare) {
        this.localHasQuestionare = newVal;
      }
    },
    localQuestionares: {
      handler(newVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(this.questionares)) {
          this.$emit("update:questionares", newVal);
        }
      },
      deep: true,
    },
    localHasQuestionare(newVal) {
      if (newVal !== this.hasQuestionare) {
        this.$emit("update:hasQuestionare", newVal);
      }
    },
  },
  methods: {
    handleQuestionareChange() {
      if (this.localHasQuestionare) {
        this.localQuestionares.push({ qid: null, roles: [] });
      } else {
        this.localQuestionares = [];
      }
    },
    addQuestionare() {
      this.localQuestionares.push({ qid: null, roles: [] });
    },
    removeQuestionare(index) {
      this.localQuestionares.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.setting-item {
  min-height: 48px;
  display: flex;
  align-items: center;
}

.setting-label {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.questionare-card {
  transition: all 0.3s ease;
}

.questionare-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
</style>
